<template>
    <b-card-body no-body>
        <b-form-row class="pt-3">
            <b-col cols="12">
                <b-row>
                    <b-col cols="8" class="d-flex justify-content-center align-items-center">
                        <lg-form-input v-model="nome" label="Nome:" @keyup.enter="buscarConfiguracao" />
                    </b-col>
                    <b-col cols="4" class="d-flex justify-content-center align-items-center">
                        <b-button id="btnBuscarP" class="mr-2 my-2" size="sm" pill variant="primary"
                            @click="buscarConfiguracao">
                            <div class="btn-size-alinhamento">

                                <b-icon icon="search" />
                                <b-tooltip target="btnBuscarP" title="Buscar"></b-tooltip>
                            </div>
                        </b-button>
                        <b-button id="btnLimparP" class="mr-2 my-2" size="sm" pill variant="primary"
                            @click="limparFiltro">
                            <div class="btn-size-alinhamento">

                                <b-icon icon="eraser" />
                                <b-tooltip target="btnLimparP" title="Limpar"></b-tooltip>
                            </div>
                        </b-button>
                    </b-col>
                </b-row>
            </b-col>
        </b-form-row>
        <b-table responsive :busy="busy" small class="mt-2" :hover="true" show-empty :items="configuracoes"
            :fields="camposTabela">
            <template #empty>
                <p>Nenhum registro encontrado</p>
            </template>
            <template #table-busy>
                <div class="text-center text-primary my-2">
                    <b-spinner class="align-middle"></b-spinner>
                    <strong> Carregando...</strong>
                </div>
            </template>

            <template #cell(acoes)="row">
                <b-button id="btnEditar" size="sm" variant="primary" @click="editar(row.item)">
                    <b-icon icon="pencil-square" />
                    <b-tooltip target="btnEditar" title="Editar..."></b-tooltip>
                </b-button>
            </template>
            <template #cell(valorPropriedadeLabel)="row">
                {{ row.item.valorPropriedadeLabel }}
            </template>
        </b-table>
        <AlmoxarifadoCentralModal v-if="showAlmoxarifadoCentralModal" :configuracao="configuracaoEdit"
            @salvo="onConfiguracaoSalva" @close="onModalClose" />
        <EmailConfigModal v-if="showEmailConfigModal" :configuracao="configuracaoEdit" @salvo="onConfiguracaoSalva"
            @close="onModalClose" />
        <ConfiguracaoSimplesModal v-if="showConfiguracaoSimplesModal" :configuracao="configuracaoEdit"
            @salvo="onConfiguracaoSalva" @close="onModalClose" />
        <DepartamentoResponsavelModal v-if="showDepartamentoResponsavelModal" :configuracao="configuracaoEdit"
            @salvo="onConfiguracaoSalva" @close="onModalClose" />
        <AlertaProcessoModal v-if="showAlertaProcessoModal" :configuracao="configuracaoEdit"
            @salvo="onConfiguracaoSalva" @close="onModalClose" />
        <PrazoItemBemPermanenteModal v-if="showPrazoItemBemPermanenteModal" :configuracao="configuracaoEdit"
            @salvo="onConfiguracaoSalva" @close="onModalClose" />
        <ConfiguracaoGeralModal v-if="showConfiguracaoGeralModal" :configuracao="configuracaoEdit"
            @salvo="onConfiguracaoSalva" @close="onModalClose" />
        <ConfiguracaoGeralLogicaModal v-if="showConfiguracaoGeralLogicaModal" :configuracao="configuracaoEdit"
            @salvo="onConfiguracaoSalva" @close="onModalClose" />
        <PatrimonioInventarioAnualModal v-if="showPatrimonioInventarioAnualModal" :configuracao="configuracaoEdit"
            @salvo="onConfiguracaoSalva" @close="onModalClose" />
        <EstadoConservacaoIbpModal v-if="showEstadoConservacaoIbpModal" :configuracao="configuracaoEdit"
            @salvo="onConfiguracaoSalva" @close="onModalClose" />

        <ClasseIbpModal v-if="showClasse" :configuracao="configuracaoEdit" @salvo="onConfiguracaoSalva"
            @close="onModalClose" />


        <ProdutoIbpModal v-if="showProduto" :configuracao="configuracaoEdit" @salvo="onConfiguracaoSalva"
            @close="onModalClose" />

        <DepartamentoIbpModal v-if="showDepartamento" :configuracao="configuracaoEdit" @salvo="onConfiguracaoSalva"
            @close="onModalClose" />




        <ManutencaoPatrimonialModal v-if="showManutencaoPatrimonialModal" :configuracao="configuracaoEdit"
            @salvo="onConfiguracaoSalva" @close="onModalClose" />
        <UsuarioAcessoTotalEstornoBaixaModal v-if="showUsuarioComAcessoTotalEstornoBaixaModal"
            :configuracao="configuracaoEdit" @salvo="onConfiguracaoSalva" @close="onModalClose" />
        <UsuarioAcessoTotalEstornoBaixaModal v-if="showUsuarioComAcessoTotalEstornoBaixaModal"
            :configuracao="configuracaoEdit" @salvo="onConfiguracaoSalva" @close="onModalClose" />

    </b-card-body>
</template>

<script>
import ConfiguracaoSistemaService from "@/core/api/ConfiguracaoSistemaService";
import LgFormInput from "@/core/components/Form/LgFormInput.vue";
import { ListResourceMixin } from "@/core/mixins/resource";
import ConfirmMixin from "@/core/mixins/confirm";
import Swal from "sweetalert2";
import AlmoxarifadoCentralModal
    from "@/modules/administrador/painel-de-configuracao/components/modal/AlmoxarifadoCentralModal.vue";
import EmailConfigModal from "@/modules/administrador/painel-de-configuracao/components/modal/EmailConfigModal.vue";
import ConfiguracaoSimplesModal
    from "@/modules/administrador/painel-de-configuracao/components/modal/ConfiguracaoSimplesModal.vue";
import DepartamentoResponsavelModal
    from "@/modules/administrador/painel-de-configuracao/components/modal/DepartamentoResponsavelModal.vue";
import AlertaProcessoModal
    from "@/modules/administrador/painel-de-configuracao/components/modal/AlertaProcessoModal.vue";
import PrazoItemBemPermanenteModal
    from "@/modules/administrador/painel-de-configuracao/components/modal/PrazoItemBemPermanenteModal.vue";
import ConfiguracaoGeralModal
    from "@/modules/administrador/painel-de-configuracao/components/modal/ConfiguracaoGeralModal.vue";
import ConfiguracaoGeralLogicaModal
    from "@/modules/administrador/painel-de-configuracao/components/modal/ConfiguracaoGeralLogicaModal.vue";
import PatrimonioInventarioAnualModal
    from "@/modules/administrador/painel-de-configuracao/components/modal/PatrimonioInventarioAnualModal.vue";
import EstadoConservacaoIbpModal
    from "@/modules/administrador/painel-de-configuracao/components/modal/EstadoConservacaoIbpModal.vue";
import ManutencaoPatrimonialModal
    from "@/modules/administrador/painel-de-configuracao/components/modal/ManutencaoPatrimonialModal.vue";
import UsuarioAcessoTotalEstornoBaixaModal
    from "@/modules/administrador/painel-de-configuracao/components/modal/UsuarioAcessoTotalEstornoBaixaModal.vue";

import ClasseIbpModal
    from "@/modules/administrador/painel-de-configuracao/components/modal/ClasseIbpModal.vue";

import ProdutoIbpModal
    from "@/modules/administrador/painel-de-configuracao/components/modal/ProdutoIbpModal.vue";
import DepartamentoIbpModal
    from "@/modules/administrador/painel-de-configuracao/components/modal/DepartamentoIbpModal.vue";


export default {
    components: {

        UsuarioAcessoTotalEstornoBaixaModal,
        ManutencaoPatrimonialModal,
        EstadoConservacaoIbpModal,
        PatrimonioInventarioAnualModal,
        ConfiguracaoGeralLogicaModal,
        ConfiguracaoGeralModal,
        PrazoItemBemPermanenteModal,
        AlmoxarifadoCentralModal,
        EmailConfigModal,
        ConfiguracaoSimplesModal,
        DepartamentoResponsavelModal,
        AlertaProcessoModal,
        LgFormInput,
        ClasseIbpModal,
        DepartamentoIbpModal,
        ProdutoIbpModal
    },
    data() {
        return {
            busy: false,
            nome: "",
            configuracoes: [],
            configuracaoEdit: {
                id: null,
                ano: null,
                dataInicio: null,
                dataFim: null,
                departamentoId: null,
                departamentoNome: "",
            },
            showAlmoxarifadoCentralModal: false,
            showEmailConfigModal: false,
            showConfiguracaoSimplesModal: false,
            showDepartamentoResponsavelModal: false,
            showAlertaProcessoModal: false,
            showPrazoItemBemPermanenteModal: false,
            showConfiguracaoGeralModal: false,
            showConfiguracaoGeralLogicaModal: false,
            showPatrimonioInventarioAnualModal: false,
            showEstadoConservacaoIbpModal: false,
            showClasse: false,
            showDepartamento: false,
            showProduto: false,
            showManutencaoPatrimonialModal: false,
            showUsuarioComAcessoTotalEstornoBaixaModal: false,
            camposTabela: [
                { key: "tituloPropriedade", label: "Nome" },
                { label: "Valor", key: "valorPropriedadeLabel" },
                { key: "acoes", label: "", tdClass: "text-center", thClass: "text-center" },
            ],
        };
    },
    methods: {
        async buscarConfiguracao() {
            this.busy = true;
            const response = await ConfiguracaoSistemaService.buscarPorTipo(9, this.nome);
            this.configuracoes = response.data;
            this.busy = false;
        },
        async limparFiltro() {
            this.nome = "";
            this.configuracoes = [];
            try {
                const response = await ConfiguracaoSistemaService.buscarPorTipo(9, this.nome);
                this.configuracoes = response.data;
            } catch (error) {
                console.error("Erro ao buscar configuração:", error);
            }
        },
        editar(item) {
            this.configuracaoEdit = { ...item };
            switch (item.grupoConfiguracaoSistemaId) {
                case 1:
                    this.showConfiguracaoSimplesModal = true;
                    break;
                case 2:
                    this.showConfiguracaoGeralModal = true;
                    break
                case 6:
                    this.showEmailConfigModal = true;
                    break;
                case 7:
                    this.showDepartamentoResponsavelModal = true;
                    break;
                case 13:
                    this.showAlertaProcessoModal = true;
                    break;
                case 14:
                    this.showPrazoItemBemPermanenteModal = true;
                    break;
                case 26:
                    this.showAlmoxarifadoCentralModal = true;
                    break;
                case 27:
                    this.showEstadoConservacaoIbpModal = true;
                    break;
                case 29:
                    this.showManutencaoPatrimonialModal = true;
                    break;
                case 30:
                    this.showUsuarioComAcessoTotalEstornoBaixaModal = true;
                    break;
                case 31:
                    this.showPatrimonioInventarioAnualModal = true;
                    break;

                case 36:
                    this.showClasse = true;
                    break;

                case 37:
                    this.showProduto = true;
                    break;

                case 38:
                    this.showDepartamento = true;
                    break;

                case 3:
                    if (item.id === 183) {
                        Swal.fire({
                            title: "Atenção",
                            text: "Este parâmetro não poderá ser modificado, pois o mesmo influenciará no cálculo do preço médio",
                            icon: "warning",
                            confirmButtonText: "OK",
                        });
                    } else {
                        this.showConfiguracaoGeralLogicaModal = true;
                    }
                    break;
                default:
                    break;
            }
        },
        onConfiguracaoSalva() {
            this.buscarConfiguracao();
            this.showConfiguracaoSimplesModal = false;
            this.showEmailConfigModal = false;
            this.showAlmoxarifadoCentralModal = false;
            this.showDepartamentoResponsavelModal = false;
            this.showAlertaProcessoModal = false;
            this.showPrazoItemBemPermanenteModal = false;
            this.showConfiguracaoGeralModal = false;
            this.showConfiguracaoGeralLogicaModal = false;
            this.showPatrimonioInventarioAnualModal = false;
            this.showEstadoConservacaoIbpModal = false;
            this.showClasse = false;
            this.showProduto = false;
            this.showDepartamento = false;
            this.showManutencaoPatrimonialModal = false;
            this.showUsuarioComAcessoTotalEstornoBaixaModal = false;
        },
        onModalClose() {
            this.showConfiguracaoSimplesModal = false;
            this.showEmailConfigModal = false;
            this.showAlmoxarifadoCentralModal = false;
            this.showDepartamentoResponsavelModal = false;
            this.showAlertaProcessoModal = false;
            this.showPrazoItemBemPermanenteModal = false;
            this.showConfiguracaoGeralModal = false;
            this.showConfiguracaoGeralLogicaModal = false;
            this.showPatrimonioInventarioAnualModal = false;
            this.showEstadoConservacaoIbpModal = false;
            this.showClasse = false;
            this.showProduto = false;
            this.showDepartamento = false;
            this.showManutencaoPatrimonialModal = false;
            this.showUsuarioComAcessoTotalEstornoBaixaModal = false;
        },
    },
    mixins: [ListResourceMixin, ConfirmMixin],
    async mounted() {
        await this.buscarConfiguracao();
    },
};
</script>
